import {
  ChevronsLeft,
  ChevronsRight,
  Trash,
  XCircle,
  ChevronDown,
  Pencil,
  Check,
  SlidersHorizontal,
  ArrowUpAZ,
  ArrowDownZA,
  ArrowDown10,
  ArrowUp10,
  ArrowUpDown,
  CheckCircle,
  Download,
  Search,
  CircleX,
  ChevronLeft,
  ChevronRight,
  X,
  XCircleIcon,
} from 'lucide-react';
import { toast } from 'react-toastify';
import axios from 'axios';
import host from '../../global';
import { useEffect, useRef, useState } from 'react';
import Loader from '../Loader';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  Typography,
} from '@mui/material';
import { Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PlatformCalendar from './platformCalendar';
import '../../css/platformCalendar.css';
import '../../css/CandidateReports.css';
import { useLocation, useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

import ConfirmationDialog from './ConfirmationDialog';
import { useTheme } from '../../hooks/useTheme';
import { useSelector } from 'react-redux';
import { calendarOverrideStyles } from './datePickerStyles';
import { confirmCompanyDetails, useCompanyDetailsGate } from "../../utils/companyProfileCheck";

const ActivityOrgAdmin = () => {
  const accessToken = sessionStorage.getItem('accessToken');
  const { state, pathname } = useLocation();
  const { upload_id = null } = state || {};

  // getting Theme From Store for passing to DateRangePicker
  const { theme } = useTheme();

  // Get current job data from browser history state or location state
  const getCurrentJobData = () => {
    try {
      const historyState = window.history.state;
      if (historyState?.jd_id) {
        return historyState;
      }
      if (state?.jd_id) {
        return state;
      }
      return null;
    } catch (error) {
      console.warn('Could not access history state:', error);
      return state || null;
    }
  };

  const [currentJobData, setCurrentJobData] = useState(getCurrentJobData());
  const [notification, setNotification] = useState([]);
  const [position, setPosition] = useState('');
  const [showDetails, setShowDetails] = useState(false);
  const [activeTab, setActiveTab] = useState('shortlisted');
  const [isLoading, setIsLoading] = useState(false);
  const [isFetchingAllCandidates, setIsFetchingAllCandidates] = useState(false); // Prevent multiple calls
  const [shortlisted, setShortlisted] = useState([]);
  const [retrofit, setRetrofit] = useState([]);
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [selectedShortlistedCandidates, setSelectedShortlistedCandidates] =
    useState([]);
  const [invalidData, setInvalidData] = useState([]);
  const [resumeScoreThreshold, setResumeScoreThreshold] = useState(60);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [currentReport, setCurrentReport] = useState(null);
  const [candidateUniqueID, setCandidateUniqueID] = useState(null);
  const [newEmail, setNewEmail] = useState('');
  const [currentCandidate, setCurrentCandidate] = useState(null);
  const [selectAllShortlisted, setSelectAllShortlisted] = useState(false);
  const [selectAllRetrofit, setSelectAllRetrofit] = useState(false);
  const [currentUploadId, setCurrentUploadId] = useState(null);
  const [isDeletePopup, setIsDeletePopup] = useState(false);
  const [isSchedulePopup, setIsSchedulePopup] = useState(false);
  // The company name question comes before the date and time, not after
  const schedulePopupOpen = useCompanyDetailsGate(isSchedulePopup, () => setIsSchedulePopup(false));
  const [dateRange, setDateRange] = useState([null, null]);
  const [isJobRoleOpen, setIsJobRoleOpen] = useState(false);
  const [selectedNotificationId, setSelectedNotificationId] = useState(null);
  const [isSortOpen, setIsSortOpen] = useState(false);
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const jobRoleDropdownRef = useRef(null);
  const sortDropdownRef = useRef(null);
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);
  const [tempSelectedFilter, setTempSelectedFilter] = useState('All');
  const [selectedFilter, setSelectedFilter] = useState('All');
  const [filterDateRange, setFilterDateRange] = useState([null, null]);
  const [tempFilterDateRange, setTempFilterDateRange] = useState([null, null]);
  const filterRef = useRef(null);
  const calendarRef = useRef(null);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  const org_id = useSelector((state)=>state.userSlice.org_id);

  // Helper function to get upload ID for candidate operations
  const getUploadIdForCandidate = (candidate) => {
    return currentUploadId || candidate?.upload_id;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        sortDropdownRef.current &&
        !sortDropdownRef.current.contains(event.target)
      ) {
        setIsSortOpen(false);
      }
      if (
        jobRoleDropdownRef.current &&
        !jobRoleDropdownRef.current.contains(event.target)
      ) {
        setIsJobRoleOpen(false);
      }
      if (
        filterRef.current &&
        !filterRef.current.contains(event.target) &&
        !calendarRef.current?.contains(event.target)
      ) {
        setShowFilterDropdown(false);
        setIsCalendarOpen(false);
      }
    };

    const handleJobRoleChange = (event) => {
      setCurrentJobData(event.detail);
      setNotification([]);
      setShowDetails(false);

      // Manually trigger refetch with new job data
      if (upload_id) {
        fetchCandidates(upload_id);
      } else {
        fetchAllCandidates();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    window.addEventListener('jobRoleChanged', handleJobRoleChange);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('jobRoleChanged', handleJobRoleChange);
    };
  }, []);

  useEffect(() => {
    setShowDetails(false);
    setIsDeletePopup(false);
    setIsSchedulePopup(false);
    setDateRange([null, null]);

    // Simplified: directly load candidates instead of notifications
    if (upload_id) {
      fetchCandidates(upload_id);
    } else {
      fetchAllCandidates();
    }
  }, [accessToken, upload_id]);

  useEffect(() => {
    setSelectAllShortlisted(
      shortlisted.length > 0 &&
        selectedShortlistedCandidates.length === shortlisted.length,
    );
  }, [selectedShortlistedCandidates, shortlisted]);

  useEffect(() => {
    setSelectAllRetrofit(
      retrofit.length > 0 && selectedCandidates.length === retrofit.length,
    );
  }, [selectedCandidates, retrofit]);

  useEffect(() => {
    setCurrentPage(1);
  }, [activeTab]);

  const formatDateRange = (range) => {
    if (!range[0] || !range[1]) return 'Select Date Range';
    return `${range[0].toLocaleDateString()} to ${range[1].toLocaleDateString()}`;
  };


  const fetchCandidates = async (uploadId) => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${host}/resumes`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        params: {
          upload_id: uploadId,
        },
      });
      const fetchedCandidates = response.data.data;
      let score_threshold = response.data.resume_score_threshold;
      setIsLoading(false);
      setResumeScoreThreshold(score_threshold);

      if (Array.isArray(fetchedCandidates)) {
        // Add upload_id to each candidate for consistency with fetchAllCandidates
        const candidatesWithUploadId = fetchedCandidates.map((candidate) => ({
          ...candidate,
          upload_id: uploadId,
        }));

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isValidEmail = (email) => {
          return email && typeof email === 'string' && emailRegex.test(email);
        };
        const shortlistedCandidates = candidatesWithUploadId.filter(
          (c) => c.score >= score_threshold && isValidEmail(c.candidate_email),
        );

        const retrofitCandidates = candidatesWithUploadId.filter(
          (c) =>
            c.score < score_threshold &&
            c.score !== null &&
            isValidEmail(c.candidate_email),
        );

        const invalidCandidates = candidatesWithUploadId.filter(
          (c) =>
            !isValidEmail(c.candidate_email) ||
            c.score === null ||
            c.candidate_email === 'not provided' ||
            c.candidate_email === '',
        );

        setShortlisted(shortlistedCandidates);
        setRetrofit(retrofitCandidates);
        setInvalidData(invalidCandidates);
        setCurrentPage(1);
      } else {
        console.error('Unexpected data format:', fetchedCandidates);
        toast.error('Invalid data format received from server.');
        setError('Invalid data format');
      }
    } catch (error) {
      setIsLoading(false);
      if (error.response) {
        const status = error.response.status;
        const detail = error.response.data.detail;
        if (status === 401) {
          sessionStorage.removeItem('accessToken');
          toast.error(`Unauthorized: ${detail}`);
          setError('Unauthorized');
        } else if (status === 404 || status === 500) {
          localStorage.setItem(`results_empty_${uploadId}`, 'true');
        } else {
          toast.error(`Error: ${detail}`);
          setError(detail);
        }
      } else {
        toast.error('An unexpected error occurred. Please try again.');
        setError('Unexpected error');
      }
    }
  };

  const downloadExcel = () => {
    if (currentData.length === 0) {
      toast.error('No data available to download.');
      return;
    }

    const data = getCurrentData().map((candidate, index) => ({
      'Sr. No.': startIndex + index + 1,
      'Candidate Name': candidate.name || 'N/A',
      'Email Id': candidate.candidate_email || 'Not Provided',
      Score: candidate.score,
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      activeTab.charAt(0).toUpperCase() + activeTab.slice(1),
    );

    const wscols = [{ wch: 10 }, { wch: 30 }, { wch: 40 }, { wch: 10 }];
    worksheet['!cols'] = wscols;

    XLSX.writeFile(
      workbook,
      `${activeTab}_candidates_${new Date().toISOString().split('T')[0]}.xlsx`,
    );
  };

  const handleViewResume = async () => {
    if (currentReport.resume_s3_url) {
      try {
        const response = await axios.get(
          `${host}/download-resumes3?resume_s3_url=${encodeURIComponent(currentReport.resume_s3_url)}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
            responseType: 'blob',
          },
        );

        const contentDisposition = response.headers['content-disposition'];
        const contentType =
          response.headers['content-type'] || 'application/octet-stream';

        let filename = `${currentReport.name}_resume.pdf`;
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(
            /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
          );
          if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1].replace(/['"]/g, '');
          }
        } else {
          const candidateName = (currentReport.name || 'candidate')
            .replace(/[^a-zA-Z0-9\s]/g, '')
            .replace(/\s+/g, '_');
          filename = `${candidateName}_resume`;
        }

        let extension = 'pdf';
        if (contentType.includes('wordprocessingml')) extension = 'docx';
        else if (contentType.includes('msword')) extension = 'doc';
        else if (contentType.includes('pdf')) extension = 'pdf';

        if (!filename.endsWith(`.${extension}`)) {
          filename = `${filename}.${extension}`;
        }

        const blob = new Blob([response.data], { type: contentType });

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
          const downloadUrl = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = downloadUrl;
          link.download = filename;
          link.style.display = 'none';
          link.setAttribute('target', '_self');

          document.body.appendChild(link);

          setTimeout(() => {
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
          }, 100);
        }

        toast.success('Resume downloaded successfully');
      } catch (error) {
        console.error('Download error:', error);

        if (error.response?.status === 404) {
          const errorMessage =
            error.response?.data?.detail || 'Resume not found';
          toast.error(errorMessage);
        } else if (error.response?.status === 401) {
          toast.error('Unauthorized access. Please login again.');
        } else if (error.response?.status === 400) {
          const errorMessage =
            error.response?.data?.detail || 'Invalid request';
          toast.error(errorMessage);
        } else if (error.response?.status === 500) {
          toast.error('Server error. Please try again later.');
        } else {
          toast.error('Download failed. Please try again.');
        }
      }
    }
  };

  const getPathColor = (val) => {
    switch (true) {
      case val >= 60:
        return '#34B53A';
      case val >= 30 && val < 60:
        return '#FFB200';
      case val >= 0 && val < 30:
        return '#DC0000';
      default:
        return 'gray';
    }
  };

  const getScoreColorGradient = (score) => {
    switch (true) {
      case score >= 60:
        return 'rgba(0,255,0,0.2)';
      case score >= 30 && score < 60:
        return 'rgba(255, 255, 0, 0.2)';
      case score >= 0 && score < 30:
        return 'rgba(255, 0, 0, 0.2)';
      default:
        return 'text-[#CCCCCCE5]';
    }
  };

  const SkillBadge = ({ skill, status }) => {
    return (
      <div className="flex items-center gap-1.5">
        <span className="dark:text-gray-300 text-textSecondary">{skill}</span>
        {status === 'yes' ? (
          <CheckCircle className="w-4 h-4 text-green-500" />
        ) : (
          <XCircle className="w-4 h-4 text-red-500" />
        )}
      </div>
    );
  };


  const handleNotificationClick = async (upload_id, job_role) => {
    setPosition(job_role);
    setCurrentUploadId(upload_id);
    setSelectedNotificationId(upload_id);
    setShowDetails(true);
    // REMOVED: read status update - notifications no longer used
    await fetchCandidates(upload_id);
  };

  // Get filtered notifications based on current filters
  const getFilteredNotifications = () => {
    return notification.filter((notif) => {
      // Filter by selected ZIP
      if (selectedFilter !== 'All' && notif.upload_id !== selectedFilter) {
        return false;
      }

      // Filter by date range
      if (filterDateRange[0] && filterDateRange[1]) {
        const uploadDate = new Date(notif.bulk_upload_date);
        const startDate = new Date(filterDateRange[0]);
        const endDate = new Date(filterDateRange[1]);

        // Set time to start and end of day for proper comparison
        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(23, 59, 59, 999);
        uploadDate.setHours(0, 0, 0, 0);

        return uploadDate >= startDate && uploadDate <= endDate;
      }

      return true;
    });
  };

  // Fetch all candidates when "All" is selected
  const fetchAllCandidates = async () => {
    // Prevent multiple simultaneous calls
    if (isFetchingAllCandidates) {
      return;
    }

    setIsFetchingAllCandidates(true);
    setIsLoading(true);

    try {
      // Get current job for filtering
      const currentJob = currentJobData || getCurrentJobData();
      const jdId = currentJob?.jd_id || 'all';

      console.log('Fetching bulk candidates for job:', jdId);

      const response = await axios.get(`${host}/resumes/bulk`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        params: {
          jd_id: jdId,
        },
      });

      const { notifications, all_candidates, resume_score_threshold } =
        response.data;

      console.log(
        `Bulk fetch completed: ${notifications.length} uploads, ${all_candidates.length} candidates`,
      );

      // Set notifications and threshold - same as before
      setNotification(notifications);
      setResumeScoreThreshold(resume_score_threshold);

      if (notifications.length === 0) {
        setShortlisted([]);
        setRetrofit([]);
        setInvalidData([]);
        setIsLoading(false);
        setIsFetchingAllCandidates(false);
        setShowDetails(true);
        return;
      }

      setShowDetails(true);

      // Apply date range filtering to notifications (same logic)
      const notificationsToUse = notifications.filter((notif) => {
        if (filterDateRange[0] && filterDateRange[1]) {
          const uploadDate = new Date(notif.bulk_upload_date);
          const startDate = new Date(filterDateRange[0]);
          const endDate = new Date(filterDateRange[1]);
          startDate.setHours(0, 0, 0, 0);
          endDate.setHours(23, 59, 59, 999);
          return uploadDate >= startDate && uploadDate <= endDate;
        }
        return true;
      });

      if (notificationsToUse.length === 0) {
        setShortlisted([]);
        setRetrofit([]);
        setInvalidData([]);
        setIsLoading(false);
        setIsFetchingAllCandidates(false);
        return;
      }

      // Filter candidates by date range if applied
      let filteredCandidates = all_candidates;
      if (filterDateRange[0] && filterDateRange[1]) {
        const filteredUploadIds = new Set(
          notificationsToUse.map((n) => n.upload_id),
        );
        filteredCandidates = all_candidates.filter((c) =>
          filteredUploadIds.has(c.upload_id),
        );
      }

      // SAME CATEGORIZATION LOGIC - no changes
      if (filteredCandidates.length > 0) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isValidEmail = (email) => {
          return email && typeof email === 'string' && emailRegex.test(email);
        };

        const shortlistedCandidates = filteredCandidates.filter(
          (c) =>
            c.score >= resume_score_threshold &&
            isValidEmail(c.candidate_email),
        );

        const retrofitCandidates = filteredCandidates.filter(
          (c) =>
            c.score < resume_score_threshold &&
            c.score !== null &&
            isValidEmail(c.candidate_email),
        );

        const invalidCandidates = filteredCandidates.filter(
          (c) =>
            !isValidEmail(c.candidate_email) ||
            c.score === null ||
            c.candidate_email === 'not provided' ||
            c.candidate_email === '',
        );

        setShortlisted(shortlistedCandidates);
        setRetrofit(retrofitCandidates);
        setInvalidData(invalidCandidates);
      } else {
        setShortlisted([]);
        setRetrofit([]);
        setInvalidData([]);
      }

      setCurrentPage(1);
      setIsLoading(false);
      setIsFetchingAllCandidates(false);
    } catch (error) {
      setIsLoading(false);
      setIsFetchingAllCandidates(false);
      console.error('Error fetching bulk candidates:', error);

      // No fallback - bulk endpoint is the only method now
      toast.error('Failed to load candidates. Please try again.');
    }
  };

  // REMOVED: Notification-based fallback method - using only bulk endpoint now
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setCurrentPage(1);
    setSortColumn(null);
    setSortDirection(null);
    if (tab === 'shortlisted') {
      setSelectedCandidates([]);
      setSelectAllRetrofit(false);
    } else if (tab === 'retrofit') {
      setSelectedShortlistedCandidates([]);
      setSelectAllShortlisted(false);
    } else if (tab === 'invalid') {
      setSelectedShortlistedCandidates([]);
      setSelectedCandidates([]);
      setSelectAllShortlisted(false);
      setSelectAllRetrofit(false);
    }
  };

  const handleCheckboxChange = (candidate) => {
    setSelectedCandidates((prevSelected) => {
      const isSelected = prevSelected.some(
        (c) => c.unique_id === candidate.unique_id,
      );
      const newSelected = isSelected
        ? prevSelected.filter((c) => c.unique_id !== candidate.unique_id)
        : [...prevSelected, candidate];
      return newSelected;
    });
  };

  const handleShortlistCheckboxChange = (candidate) => {
    setSelectedShortlistedCandidates((prev) => {
      const isSelected = prev.some((c) => c.unique_id === candidate.unique_id);
      const newSelected = isSelected
        ? prev.filter((c) => c.unique_id !== candidate.unique_id)
        : [...prev, candidate];
      return newSelected;
    });
  };

  const handleSelectAllShortlisted = () => {
    if (selectAllShortlisted) {
      setSelectedShortlistedCandidates([]);
      setSelectAllShortlisted(false);
    } else {
      setSelectedShortlistedCandidates([...shortlisted]);
      setSelectAllShortlisted(true);
    }
  };

  const handleSelectAllRetrofit = () => {
    if (selectAllRetrofit) {
      setSelectedCandidates([]);
      setSelectAllRetrofit(false);
    } else {
      setSelectedCandidates([...retrofit]);
      setSelectAllRetrofit(true);
    }
  };

  const scheduleInterviewForAll = async () => {
    if (selectedShortlistedCandidates.length === 0) {
      toast.error(
        'Please select at least one candidate to schedule interviews.',
      );
      return;
    }
    if (!dateRange[0] || !dateRange[1]) {
      toast.error('Please select a valid date range for the interviews.');
      return;
    }
    if (dateRange[0] >= dateRange[1]) {
      toast.error('Start date must be before end date.');
      return;
    }

    if (!(await confirmCompanyDetails("invite"))) return;

    setIsLoading(true);
    let candidatesByUpload = {};
    const selectedUniqueIds = selectedShortlistedCandidates.map(
      (candidate) => candidate.unique_id,
    );

    try {
      // Handle both single upload and multiple uploads scenarios
      if (currentUploadId) {
        console.log({currentUploadId})
        // Single upload scenario - use existing logic
        const payload = {
          unique_ids: selectedUniqueIds,
          start_date: dateRange[0].toISOString(),
          end_date: dateRange[1].toISOString(),
        };

        console.log(
          'Scheduling interviews for single upload:',
          payload,
          'upload_id:',
          currentUploadId,
        );

        await axios.post(`${host}/schedule_interviews`, payload, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          params: {
            upload_id: currentUploadId,
            org_id
          },
        });
      } else {
        // Multiple uploads scenario - group by upload_id and schedule separately
        candidatesByUpload = selectedShortlistedCandidates.reduce(
          (groups, candidate) => {
            const uploadId = candidate.upload_id;
            if (!uploadId) {
              console.warn('Candidate missing upload_id:', candidate);
              return groups;
            }
            if (!groups[uploadId]) {
              groups[uploadId] = [];
            }
            groups[uploadId].push(candidate);
            return groups;
          },
          {},
        );

        console.log(
          'Scheduling interviews for multiple uploads:',
          candidatesByUpload,
        );

        // Schedule interviews for each upload group
        const schedulingPromises = Object.entries(candidatesByUpload).map(
          async ([uploadId, candidates]) => {
            const candidateIds = candidates.map((c) => c.unique_id);
            const payload = {
              unique_ids: candidateIds,
              start_date: dateRange[0].toISOString(),
              end_date: dateRange[1].toISOString(),
            };
            // console.log("-----------------------------------------------------",org_id)
            return axios.post(`${host}/schedule_interviews`, payload, {
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
              params: {
                upload_id: uploadId,
                org_id
              },
            });
          },
        );

        await Promise.all(schedulingPromises);
      }

      // Remove scheduled candidates from the UI
      setShortlisted((prev) =>
        prev.filter(
          (candidate) => !selectedUniqueIds.includes(candidate.unique_id),
        ),
      );

      const remainingCandidates = [
        ...shortlisted.filter(
          (candidate) => !selectedUniqueIds.includes(candidate.unique_id),
        ),
        ...retrofit,
        ...invalidData,
      ];

      // Handle notification cleanup for single upload scenario
      if (currentUploadId && remainingCandidates.length === 0) {
        const updatedNotifications = notification.filter(
          (n) => n.upload_id !== currentUploadId,
        );
        setNotification(updatedNotifications);
        if (updatedNotifications.length > 0) {
          const nextNotification = updatedNotifications[0];
          handleNotificationClick(
            nextNotification.upload_id,
            nextNotification.job_role,
            nextNotification.jd_id,
            nextNotification.read_status,
          );
        } else {
          setShowDetails(false);
        }
      }
      // For multiple uploads scenario, we don't need to handle notification cleanup
      // as we're viewing aggregated candidates from multiple uploads
      setSelectedShortlistedCandidates([]);
      setSelectAllShortlisted(false);
      setDateRange([null, null]);
      setIsSchedulePopup(false);
      setIsLoading(false);

      const candidateCount = selectedUniqueIds.length;
      const uploadInfo = currentUploadId
        ? 'single upload'
        : `${Object.keys(candidatesByUpload || {}).length} upload(s)`;

      toast.success(
        `Interviews scheduled successfully for ${candidateCount} candidate(s) from ${uploadInfo} between ${formatDateRange(dateRange)}.`,
      );
    } catch (error) {
      setIsLoading(false);
      if (error.response) {
        const status = error.response.status;
        const detail = error.response.data.detail;
        console.error('Error response:', error.response.data);
        if (status === 401) {
          sessionStorage.removeItem('accessToken');
          toast.error(`Unauthorized: ${detail}`);
        } else if (status === 422) {
          const errorDetails = detail
            .map((err) => `${err.loc.join('.')}: ${err.msg}`)
            .join('; ');
          toast.error(`Validation Error: ${errorDetails}`);
        } else if (status === 404 || status === 500) {
          toast.error(`Error: ${detail}`);
          if (
            detail.includes('No matching candidates found') ||
            detail.includes('No candidates found')
          ) {
            localStorage.setItem(`results_empty_${currentUploadId}`, 'true');
            const remainingCandidates = [
              ...shortlisted.filter(
                (candidate) => !selectedUniqueIds.includes(candidate.unique_id),
              ),
              ...retrofit,
              ...invalidData,
            ];
            if (remainingCandidates.length === 0) {
              const updatedNotifications = notification.filter(
                (n) => n.upload_id !== currentUploadId,
              );
              setNotification(updatedNotifications);
              if (updatedNotifications.length > 0) {
                const nextNotification = updatedNotifications[0];
                handleNotificationClick(
                  nextNotification.upload_id,
                  nextNotification.job_role,
                  nextNotification.jd_id,
                  nextNotification.read_status,
                );
              } else {
                setShowDetails(false);
              }
            }
          }
        } else {
          toast.error(`Failed to schedule interviews: ${detail}`);
        }
      } else {
        console.error('Unexpected error:', error);
        toast.error('An unexpected error occurred. Please try again.');
      }
    }
  };

  const deleteSelectedCandidates = async () => {
    setIsDeletePopup(false);
    const selectedEmails = selectedCandidates.map(
      (candidate) => candidate.candidate_email,
    );
    const selectedUniqueIds = selectedCandidates.map(
      (candidate) => candidate.unique_id,
    );

    // Debug logging
    console.log('BulkActivity - Bulk delete debug:', {
      selectedCandidates: selectedCandidates,
      currentUploadId: currentUploadId,
      selectedEmails: selectedEmails,
      selectedUniqueIds: selectedUniqueIds,
      candidateUploadIds: selectedCandidates.map((c) => c.upload_id),
    });

    // Check if we have currentUploadId for single upload scenario
    if (!currentUploadId) {
      // For "All Job Roles" scenario, we need to group by upload_id
      const candidatesByUpload = selectedCandidates.reduce(
        (groups, candidate) => {
          const uploadId = candidate.upload_id;
          if (!uploadId) {
            console.warn('Candidate missing upload_id:', candidate);
            return groups;
          }
          if (!groups[uploadId]) {
            groups[uploadId] = [];
          }
          groups[uploadId].push(candidate);
          return groups;
        },
        {},
      );

      console.log(
        'Bulk delete - Multiple uploads scenario:',
        candidatesByUpload,
      );

      if (Object.keys(candidatesByUpload).length === 0) {
        toast.error(
          'Unable to identify upload sources for selected candidates',
        );
        return;
      }

      // Delete from each upload separately
      try {
        const deletePromises = Object.entries(candidatesByUpload).map(
          async ([uploadId, candidates]) => {
            const emails = candidates.map((c) => c.candidate_email).join(',');
            const uniqueIds = candidates.map((c) => c.unique_id).join(',');

            return axios.delete(`${host}/deletecandidateBulkUpload`, {
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
              params: {
                upload_id: uploadId,
                emails: emails,
                unique_id: uniqueIds,
              },
            });
          },
        );

        await Promise.all(deletePromises);
        toast.success('Selected candidates deleted successfully');

        // Update UI state - remove deleted candidates from all categories
        setShortlisted((prev) =>
          prev.filter(
            (candidate) => !selectedUniqueIds.includes(candidate.unique_id),
          ),
        );
        setRetrofit((prev) =>
          prev.filter(
            (candidate) => !selectedUniqueIds.includes(candidate.unique_id),
          ),
        );
        setInvalidData((prev) =>
          prev.filter(
            (candidate) => !selectedUniqueIds.includes(candidate.unique_id),
          ),
        );
        setSelectedCandidates([]);
      } catch (error) {
        console.error(
          'BulkActivity - Bulk delete error (multiple uploads):',
          error,
        );
        if (error.response?.status === 422) {
          toast.error(`Validation Error: ${error.response.data.detail}`);
        } else {
          toast.error('Failed to delete some candidates. Please try again.');
        }
        return;
      }
    } else {
      // Single upload scenario
      try {
        const response = await axios.delete(
          `${host}/deletecandidateBulkUpload`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
            params: {
              upload_id: currentUploadId,
              emails: selectedEmails.join(','),
              unique_id: selectedUniqueIds.join(','),
            },
          },
        );
        toast.success('Selected candidates deleted successfully');

        // Update UI state - remove deleted candidates from all categories
        setShortlisted((prev) =>
          prev.filter(
            (candidate) => !selectedUniqueIds.includes(candidate.unique_id),
          ),
        );
        setRetrofit((prev) =>
          prev.filter(
            (candidate) => !selectedUniqueIds.includes(candidate.unique_id),
          ),
        );
        setInvalidData((prev) =>
          prev.filter(
            (candidate) => !selectedUniqueIds.includes(candidate.unique_id),
          ),
        );
        setSelectedCandidates([]);
        if (response.data.results_empty) {
          localStorage.setItem(`results_empty_${currentUploadId}`, 'true');
          const updatedNotifications = notification.filter(
            (n) => n.upload_id !== currentUploadId,
          );
          setNotification(updatedNotifications);
          if (updatedNotifications.length > 0) {
            const nextNotification = updatedNotifications[0];
            handleNotificationClick(
              nextNotification.upload_id,
              nextNotification.job_role,
              nextNotification.jd_id,
              nextNotification.read_status,
            );
          } else {
            setShowDetails(false);
          }
        }
      } catch (error) {
        console.error(
          'BulkActivity - Bulk delete error (single upload):',
          error,
        );
        if (error.response) {
          const status = error.response.status;
          const detail = error.response.data.detail;
          console.error(
            `Delete API Error - Status: ${status}, Detail:`,
            detail,
          );

          if (status === 401) {
            sessionStorage.removeItem('accessToken');
            toast.error(`Unauthorized: ${detail}`);
          } else if (status === 422) {
            toast.error(`Validation Error: ${detail}`);
          } else if (status === 404 || status === 500) {
            localStorage.setItem(`results_empty_${currentUploadId}`, 'true');
            toast.error(`Error: ${detail}`);
          } else {
            toast.error(`Error: ${detail}`);
          }
        } else {
          toast.error('An unexpected error occurred. Please try again.');
        }
      }
    }
  };

  const deleteSelectedShortlistedCandidates = async () => {
    setIsLoading(true);
    setIsDeletePopup(false);
    const selectedEmails = selectedShortlistedCandidates.map(
      (candidate) => candidate.candidate_email,
    );
    const selectedUniqueIds = selectedShortlistedCandidates.map(
      (candidate) => candidate.unique_id,
    );

    // Debug logging
    console.log('BulkActivity - Delete shortlisted debug:', {
      selectedShortlistedCandidates: selectedShortlistedCandidates,
      currentUploadId: currentUploadId,
      selectedEmails: selectedEmails,
      selectedUniqueIds: selectedUniqueIds,
      candidateUploadIds: selectedShortlistedCandidates.map((c) => c.upload_id),
    });

    // Check if we have currentUploadId for single upload scenario
    if (!currentUploadId) {
      // For "All Job Roles" scenario, we need to group by upload_id
      const candidatesByUpload = selectedShortlistedCandidates.reduce(
        (groups, candidate) => {
          const uploadId = candidate.upload_id;
          if (!uploadId) {
            console.warn('Shortlisted candidate missing upload_id:', candidate);
            return groups;
          }
          if (!groups[uploadId]) {
            groups[uploadId] = [];
          }
          groups[uploadId].push(candidate);
          return groups;
        },
        {},
      );

      console.log(
        'Delete shortlisted - Multiple uploads scenario:',
        candidatesByUpload,
      );

      if (Object.keys(candidatesByUpload).length === 0) {
        toast.error(
          'Unable to identify upload sources for selected candidates',
        );
        setIsLoading(false);
        return;
      }

      // Delete from each upload separately
      try {
        const deletePromises = Object.entries(candidatesByUpload).map(
          async ([uploadId, candidates]) => {
            const emails = candidates.map((c) => c.candidate_email).join(',');
            const uniqueIds = candidates.map((c) => c.unique_id).join(',');

            return axios.delete(`${host}/deletecandidateBulkUpload`, {
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
              params: {
                upload_id: uploadId,
                emails: emails,
                unique_id: uniqueIds,
              },
            });
          },
        );

        await Promise.all(deletePromises);
        toast.success('Selected shortlisted candidates deleted successfully');

        // Update UI state
        setShortlisted((prev) =>
          prev.filter(
            (candidate) => !selectedUniqueIds.includes(candidate.unique_id),
          ),
        );
        setSelectedShortlistedCandidates([]);
        setIsLoading(false);
      } catch (error) {
        console.error(
          'BulkActivity - Delete shortlisted error (multiple uploads):',
          error,
        );
        setIsLoading(false);
        if (error.response?.status === 422) {
          toast.error(`Validation Error: ${error.response.data.detail}`);
        } else {
          toast.error('Failed to delete some candidates. Please try again.');
        }
        return;
      }
    } else {
      // Single upload scenario
      try {
        const response = await axios.delete(
          `${host}/deletecandidateBulkUpload`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
            params: {
              upload_id: currentUploadId,
              emails: selectedEmails.join(','),
              unique_id: selectedUniqueIds.join(','),
            },
          },
        );
        // Update UI state - remove deleted candidates from all categories
        setShortlisted((prev) =>
          prev.filter(
            (candidate) => !selectedUniqueIds.includes(candidate.unique_id),
          ),
        );
        setRetrofit((prev) =>
          prev.filter(
            (candidate) => !selectedUniqueIds.includes(candidate.unique_id),
          ),
        );
        setInvalidData((prev) =>
          prev.filter(
            (candidate) => !selectedUniqueIds.includes(candidate.unique_id),
          ),
        );
        setSelectedShortlistedCandidates([]);
        setIsLoading(false);
        toast.success('Selected candidates deleted successfully');
        if (response.data.results_empty) {
          localStorage.setItem(`results_empty_${currentUploadId}`, 'true');
          const updatedNotifications = notification.filter(
            (n) => n.upload_id !== currentUploadId,
          );
          setNotification(updatedNotifications);
          if (updatedNotifications.length > 0) {
            const nextNotification = updatedNotifications[0];
            handleNotificationClick(
              nextNotification.upload_id,
              nextNotification.job_role,
              nextNotification.jd_id,
              nextNotification.read_status,
            );
          } else {
            setShowDetails(false);
          }
        }
      } catch (error) {
        console.error(
          'BulkActivity - Delete shortlisted error (single upload):',
          error,
        );
        setIsLoading(false);
        if (error.response) {
          const status = error.response.status;
          const detail = error.response.data.detail;
          console.error(
            `Delete API Error - Status: ${status}, Detail:`,
            detail,
          );

          if (status === 401) {
            sessionStorage.removeItem('accessToken');
            toast.error(`Unauthorized: ${detail}`);
          } else if (status === 422) {
            toast.error(`Validation Error: ${detail}`);
          } else if (status === 404 || status === 500) {
            localStorage.setItem(`results_empty_${currentUploadId}`, 'true');
            toast.error(`Error: ${detail}`);
          } else {
            toast.error(`Error: ${detail}`);
          }
        } else {
          toast.error('An unexpected error occurred. Please try again.');
        }
      }
    }
  };

  const deleteSingleCandidate = async (candidate) => {
    const uploadId = getUploadIdForCandidate(candidate);

    console.log('BulkActivity - Delete candidate debug:', {
      candidate: candidate,
      uploadId: uploadId,
      currentUploadId: currentUploadId,
      candidateUploadId: candidate?.upload_id,
      email: candidate.candidate_email,
      uniqueId: candidate.unique_id,
    });

    if (!uploadId) {
      toast.error('Unable to identify upload source for this candidate');
      return;
    }

    // Validate required parameters
    if (!candidate.unique_id) {
      toast.error('Candidate missing unique ID');
      return;
    }

    try {
      const response = await axios.delete(`${host}/deletecandidateBulkUpload`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        params: {
          upload_id: uploadId,
          emails: candidate.candidate_email || '',
          unique_id: candidate.unique_id,
        },
      });
      toast.success('Candidate deleted successfully');
      setInvalidData(invalidData.filter((c) => c !== candidate));
      if (response.data.results_empty) {
        localStorage.setItem(`results_empty_${uploadId}`, 'true');
      }
    } catch (error) {
      console.error('BulkActivity - Delete candidate error:', error);
      if (error.response) {
        const status = error.response.status;
        const detail = error.response.data.detail;
        console.error(`Delete API Error - Status: ${status}, Detail:`, detail);

        if (status === 401) {
          sessionStorage.removeItem('accessToken');
          toast.error(`Unauthorized: ${detail}`);
        } else if (status === 422) {
          toast.error(`Validation Error: ${detail}`);
        } else if (status === 404 || status === 500) {
          localStorage.setItem(`results_empty_${uploadId}`, 'true');
          toast.error(`Error: ${detail}`);
        } else {
          toast.error(`Error: ${detail}`);
        }
      } else {
        toast.error('An unexpected error occurred. Please try again.');
      }
    }
  };

  const shortlistSelectedCandidates = () => {
    const candidatesToShortlist = selectedCandidates.filter(
      (candidate) => candidate.score < resumeScoreThreshold,
    );
    setRetrofit(retrofit.filter((c) => !candidatesToShortlist.includes(c)));
    setShortlisted([...shortlisted, ...candidatesToShortlist]);
    setSelectedCandidates([]);
  };

  const handleScoreSortClick = () => {
    if (sortColumn === 'score') {
      // Toggle between desc and asc
      const newDirection = sortDirection === 'desc' ? 'asc' : 'desc';
      setSortColumn('score');
      setSortDirection(newDirection);
    } else {
      // First click - start with high to low (desc)
      setSortColumn('score');
      setSortDirection('desc');
    }
  };

  const handleNameSortClick = () => {
    if (sortColumn === 'name') {
      // Toggle between asc and desc
      const newDirection = sortDirection === 'asc' ? 'desc' : 'asc';
      setSortColumn('name');
      setSortDirection(newDirection);
    } else {
      // First click - start with A to Z (asc)
      setSortColumn('name');
      setSortDirection('asc');
    }
  };

  const saveEmailChange = async (candidate) => {
    if (!newEmail) {
      toast.error('Please enter a valid email');
      return;
    }

    if (newEmail === candidate.candidate_email) {
      toast.info('No changes made to email');
      setCandidateUniqueID(null);
      setNewEmail('');
      return;
    }

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(newEmail)) {
      toast.error(
        'Please enter a valid email address (e.g., example@gmail.com)',
      );
      return;
    }

    try {
      // Use candidate's upload_id if currentUploadId is null (when viewing "All" candidates)
      const uploadId = getUploadIdForCandidate(candidate);

      if (!uploadId) {
        toast.error('Unable to identify upload source for this candidate');
        return;
      }

      const params = new URLSearchParams({
        upload_id: uploadId,
        unique_id: candidate.unique_id,
        new_email: newEmail,
      });

      await axios.put(
        `${host}/update_candidate_email`,
        {},
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          params: params,
        },
      );

      const updatedCandidate = { ...candidate, candidate_email: newEmail };

      const updateCandidateInArray = (array) =>
        array.map((c) =>
          c.unique_id === candidate.unique_id ? updatedCandidate : c,
        );

      setShortlisted(updateCandidateInArray(shortlisted));
      setRetrofit(updateCandidateInArray(retrofit));

      if (activeTab === 'invalid') {
        const wasInvalidDueToEmail =
          !candidate.candidate_email ||
          candidate.candidate_email === 'not provided' ||
          candidate.candidate_email === '' ||
          !emailRegex.test(candidate.candidate_email);

        if (wasInvalidDueToEmail && emailRegex.test(newEmail)) {
          setInvalidData((prev) =>
            prev.filter((c) => c.unique_id !== candidate.unique_id),
          );

          if (
            candidate.score !== null &&
            candidate.score >= resumeScoreThreshold
          ) {
            setShortlisted((prev) => [...prev, updatedCandidate]);
          } else if (candidate.score !== null) {
            setRetrofit((prev) => [...prev, updatedCandidate]);
          } else {
            setInvalidData((prev) => [...prev, updatedCandidate]);
          }
        } else {
          setInvalidData(updateCandidateInArray(invalidData));
        }
      } else {
        setInvalidData(updateCandidateInArray(invalidData));
      }

      setCandidateUniqueID(null);
      setNewEmail('');
      toast.success('Email updated successfully!');

      const remainingCandidates = [
        ...shortlisted,
        ...retrofit,
        ...invalidData.filter((c) => c.unique_id !== candidate.unique_id),
        updatedCandidate,
      ];
      if (remainingCandidates.length === 0) {
        const updatedNotifications = notification.filter(
          (n) => n.upload_id !== currentUploadId,
        );
        setNotification(updatedNotifications);
        if (updatedNotifications.length > 0) {
          const nextNotification = updatedNotifications[0];
          handleNotificationClick(
            nextNotification.upload_id,
            nextNotification.job_role,
            nextNotification.jd_id,
            nextNotification.read_status,
          );
        } else {
          setShowDetails(false);
        }
      }
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        const detail = error.response.data.detail;
        if (status === 401) {
          sessionStorage.removeItem('accessToken');
          toast.error(`Unauthorized: ${detail}`);
        } else if (status === 404 || status === 500) {
          localStorage.setItem(`results_empty_${currentUploadId}`, 'true');
        } else if (status === 422) {
          toast.error(`Invalid request: ${detail}`);
        } else {
          toast.error(`Error: ${detail}`);
        }
      } else {
        toast.error('An unexpected error occurred. Please try again.');
      }
    }
  };

  const handleReportClick = (candidate) => {
    setCurrentReport({
      score: candidate.score,
      experience_match: candidate.experience_match || [],
      location_match: candidate.location_match || {},
      education_match: candidate.education_match || {},
      tech_tool_match: candidate.tech_tool_match || [],
      red_flags: candidate.red_flags || [],
      Strengths: candidate.report?.Strengths || [],
      Weaknesses: candidate.report?.Weaknesses || [],
      Suggestions: candidate.report?.Suggestions || [],
      resume_s3_url: candidate.resume_s3_url,
      name: candidate.name,
    });
    setCurrentCandidate(candidate);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setCurrentReport(null);
    setCurrentCandidate(null);
  };

  const handleFilterSelect = (filter) => {
    setTempSelectedFilter(filter);
  };

  const handleApplyFilters = () => {
    const newFilter = tempSelectedFilter;
    setSelectedFilter(newFilter);
    setFilterDateRange(tempFilterDateRange);
    setShowFilterDropdown(false);

    // Apply the filter immediately
    if (newFilter === 'All') {
      fetchAllCandidates();
    } else {
      // Find the selected notification and load its candidates
      const selectedNotification = notification.find(
        (n) => n.upload_id === newFilter,
      );
      if (selectedNotification) {
        handleNotificationClick(
          selectedNotification.upload_id,
          selectedNotification.job_role,
          selectedNotification.jd_id,
          selectedNotification.read_status,
        );
      }
    }
  };

  const handleResetFilter = () => {
    setShowFilterDropdown(false);
    setTempSelectedFilter('All');
    setSelectedFilter('All');
    setTempFilterDateRange([null, null]);
    setFilterDateRange([null, null]);
    // Load all candidates when resetting
    fetchAllCandidates();
  };

  const getActiveFilters = () => {
    const activeFilters = [];
    if (selectedFilter !== 'All') {
      const selectedNotification = notification.find(
        (n) => n.upload_id === selectedFilter,
      );
      if (selectedNotification) {
        const dateObj = new Date(selectedNotification.bulk_upload_date);
        const formattedDate = dateObj.toLocaleDateString('en-US', {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
        });
        activeFilters.push({
          label: `ZIP: ${formattedDate}`,
          onRemove: () => {
            setSelectedFilter('All');
            setTempSelectedFilter('All');
            fetchAllCandidates();
          },
        });
      }
    }
    if (filterDateRange[0] && filterDateRange[1]) {
      activeFilters.push({
        label: `Date: ${formatDateRange(filterDateRange)}`,
        onRemove: () => {
          setFilterDateRange([null, null]);
          setTempFilterDateRange([null, null]);
          fetchAllCandidates();
        },
      });
    }
    return activeFilters;
  };

  const activeFilters = getActiveFilters();
  const filterCount = activeFilters.length;

  const filteredNotifications = getFilteredNotifications();

  const getCurrentData = () => {
    let data;
    switch (activeTab) {
      case 'shortlisted':
        data = [...shortlisted];
        break;
      case 'retrofit':
        data = [...retrofit];
        break;
      case 'invalid':
        data = [...invalidData];
        break;
      default:
        data = [];
    }

    if (searchQuery.trim()) {
      data = data.filter((candidate) =>
        candidate.name?.toLowerCase().includes(searchQuery.toLowerCase()),
      );
    }

    if (sortColumn === 'name') {
      return data.sort((a, b) => {
        const nameA = (a.name || '').toLowerCase();
        const nameB = (b.name || '').toLowerCase();
        return sortDirection === 'asc'
          ? nameA.localeCompare(nameB)
          : nameB.localeCompare(nameA);
      });
    } else if (sortColumn === 'score') {
      return data.sort((a, b) => {
        const scoreA = a.score || 0;
        const scoreB = b.score || 0;
        return sortDirection === 'asc' ? scoreA - scoreB : scoreB - scoreA;
      });
    }
    return data;
  };

  const currentData = getCurrentData();
  const totalItems = currentData.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentItems = currentData.slice(startIndex, endIndex);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, 4, '...', totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(
          1,
          '...',
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages,
        );
      } else {
        pages.push(
          1,
          '...',
          currentPage - 1,
          currentPage,
          currentPage + 1,
          '...',
          totalPages,
        );
      }
    }

    return pages;
  };

  const renderTable = (data) => {
    if (data.length === 0) {
      return (
        <div className="flex items-center justify-center min-h-[200px] mt-6 border rounded-lg border-gray-700/50">
          <p className="text-gray-400 text-sm">No candidates found</p>
        </div>
      );
    }

    return (
      <>
        <div
          key={`${activeTab}-${selectedShortlistedCandidates.length}-${selectedCandidates.length}`}
          className="flex-1 mt-6  rounded-lg border-gray-700/50 overflow-hidden"
        >
          {/* Data display section */}
          {currentItems.length === 0 ? (
            <div className="flex items-center justify-center py-12">
              <div className="flex flex-col items-center text-center">
                <h2 className="text-lg font-medium text-gray-700 mb-1">
                  No candidates found
                </h2>
                <p className="text-sm text-gray-400">
                  Try adjusting your filters or search terms to see more
                  results.
                </p>
              </div>
            </div>
          ) : (
            <>
              <table className="w-full relative">
                <thead className="relative border-b border-[#5A4479D4]">
                  <div className="absolute inset-0  pointer-events-none dark:hidden"></div>

                  <tr>
                    <th className="text-left px-4 text-sm font-medium dark:text-[#CCCCCC] text-textSecondary w-12 pt-1.5">
                      {activeTab !== 'invalid' && (
                        <input
                          type="checkbox"
                          className="rounded bg-gray-700 border-gray-600 w-4 h-4 accent-blue-600"
                          checked={
                            activeTab === 'shortlisted'
                              ? selectAllShortlisted
                              : selectAllRetrofit
                          }
                          onChange={
                            activeTab === 'shortlisted'
                              ? handleSelectAllShortlisted
                              : handleSelectAllRetrofit
                          }
                          title="Select All"
                        />
                      )}
                    </th>
                    {/* <th className="text-left px-4 text-sm font-medium text-[#CCCCCC]">
                  Sr. No.
                </th> */}
                    <th className="text-left px-4 text-sm font-medium dark:text-[#CCCCCC] text-textSecondary  relative">
                      <div
                        className="flex items-center cursor-pointer"
                        onClick={handleNameSortClick}
                      >
                        Candidate Name
                        {sortColumn === 'name' ? (
                          sortDirection === 'asc' ? (
                            <ArrowUpAZ className="w-4 h-4 ml-6 dark:text-white text-textSecondary  dark:hover:text-gray-300 hover:text-gray-700" />
                          ) : (
                            <ArrowDownZA className="w-4 h-4 ml-6 dark:text-white text-textSecondary  dark:hover:text-gray-300 hover:text-gray-700" />
                          )
                        ) : (
                          <ArrowUpDown className="w-4 h-4 ml-6 dark:text-gray-400 text-textSecondary  dark:hover:text-gray-300 hover:text-gray-700" />
                        )}
                      </div>
                    </th>
                    <th className="text-left px-4 text-sm font-medium dark:text-[#CCCCCC] text-textSecondary">
                      Email Id
                    </th>
                    <th className="text-left px-4 text-sm font-medium dark:text-[#CCCCCC] text-textSecondary">
                      Created on
                    </th>
                    <th className="text-left px-4 text-sm font-medium dark:text-[#CCCCCC] text-textSecondary relative ">
                      <div
                        className="flex items-center cursor-pointer"
                        onClick={handleScoreSortClick}
                      >
                        Resume Score
                        {sortColumn === 'score' ? (
                          sortDirection === 'desc' ? (
                            <ArrowDown10 className="w-4 h-4 ml-6 dark:text-white text-textSecondary  dark:hover:text-gray-300 hover:text-gray-700" />
                          ) : (
                            <ArrowUp10 className="w-4 h-4 ml-6 dark:text-white text-textSecondary  dark:hover:text-gray-300 hover:text-gray-700" />
                          )
                        ) : (
                          <ArrowUpDown className="w-4 h-4 ml-6 dark:text-white text-textSecondary  dark:hover:text-gray-300 hover:text-gray-700" />
                        )}
                      </div>
                    </th>
                    <th className="text-left px-4 text-sm font-medium dark:text-[#CCCCCC] text-textSecondary w-24 p-7"></th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((candidate) => {
                    const isEditing = candidateUniqueID === candidate.unique_id;
                    return (
                      <tr
                        key={candidate.unique_id}
                        className="border-b dark:border-gray-700/50 border-gray-300/50 dark:hover:bg-gray-800 hover:bg-gray-100 transition-colors cursor-pointer hover:text-white"
                        // style={getRowStyle(candidate.profile_type)}
                        onClick={(e) => {
                          const checkboxColumn =
                            e.target.closest('td:nth-child(1)');
                          if (
                            checkboxColumn ||
                            e.target.tagName === 'BUTTON' ||
                            e.target.tagName === 'INPUT' ||
                            e.target.closest('button') ||
                            e.target.closest('input')
                          ) {
                            e.stopPropagation();
                            return;
                          }
                          handleReportClick(candidate);
                        }}
                      >
                        <td className="p-4">
                          {activeTab !== 'invalid' && (
                            <input
                              type="checkbox"
                              className="rounded bg-gray-700 border-gray-600 w-4 h-4 accent-blue-600"
                              checked={
                                activeTab === 'shortlisted'
                                  ? selectedShortlistedCandidates.some(
                                      (c) =>
                                        c.unique_id === candidate.unique_id,
                                    )
                                  : selectedCandidates.some(
                                      (c) =>
                                        c.unique_id === candidate.unique_id,
                                    )
                              }
                              onChange={(e) => {
                                e.stopPropagation();
                                activeTab === 'shortlisted'
                                  ? handleShortlistCheckboxChange(candidate)
                                  : handleCheckboxChange(candidate);
                              }}
                            />
                          )}
                        </td>
                        {/* <td className="p-4 text-sm text-[#CCCCCC]">
                      {startIndex + index + 1}.
                    </td> */}
                        <td className="p-4 text-sm dark:text-[#CCCCCC] text-textSecondary">
                          {candidate.name}
                        </td>
                        <td className="p-4 text-sm dark:text-[#CCCCCC] text-textSecondary">
                          {isEditing ? (
                            <input
                              type="email"
                              value={newEmail}
                              onChange={(e) => setNewEmail(e.target.value)}
                              placeholder="Enter email"
                              autoComplete="off"
                              required
                              className="bg-transparent w-full border border-gray-600 dark:text-[#CCCCCC] text-textSecondary px-2 py-1 rounded"
                            />
                          ) : (
                            candidate.candidate_email || 'Not Provided'
                          )}
                        </td>
                        <td className="p-4 text-sm dark:text-[#CCCCCC] text-textSecondary">
                          {candidate?.uploaded_on?.split('T')[0] ?? '-'}
                        </td>
                        <td className="p-4 text-sm dark:text-[#CCCCCC] text-textSecondary">
                          <div
                            className={`flex items-center justify-center border w-9 p-0.5 rounded-lg ${
                              candidate.score >= 70
                                ? 'border-green-600 dark:text-green-400 text-green-600'
                                : candidate.score >= 30
                                  ? 'border-yellow-600 dark:text-yellow-400 text-yellow-600'
                                  : 'border-red-600 dark:text-red-400 text-red-600'
                            }`}
                          >
                            <span>{candidate.score}</span>
                          </div>
                        </td>
                        <td className="p-4">
                          <div className="flex space-x-2">
                            {isEditing ? (
                              <button
                                className="p-1 rounded"
                                onClick={() => saveEmailChange(candidate)}
                              >
                                <Check
                                  size={20}
                                  className="dark:text-gray-400 text-textSecondary"
                                />
                              </button>
                            ) : (
                              <button
                                className="p-1 rounded"
                                onClick={() => {
                                  setNewEmail(candidate.candidate_email || '');
                                  setCandidateUniqueID(candidate.unique_id);
                                }}
                              >
                                <Pencil className="dark:text-[#CCCCCC] text-textSecondary h-5 w-5" />
                              </button>
                            )}
                            {activeTab === 'invalid' && (
                              <button
                                className="flex items-center gap-1 p-1 hover:bg-gray-700 rounded text-xs"
                                onClick={() => deleteSingleCandidate(candidate)}
                              >
                                <Trash
                                  size={16}
                                  className="dark:text-[#CCCCCC] text-textSecondary hover:text-red-500"
                                />
                                <span className="dark:text-[#CCCCCC] text-textSecondary hover:text-red-500">
                                  Delete
                                </span>
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </>
          )}
        </div>

        {totalPages >= 1 && (
          <div className="px-2 py-4  border-gray-700/50 flex items-center justify-between space-x-5 mt-4">
            <div className="flex items-center space-x-4 my-4">
              <span className="text-sm dark:text-[#D9D9D9] text-textSecondary">
                Showing {startIndex + 1} to {Math.min(endIndex, totalItems)} of{' '}
                {totalItems} Candidates
              </span>
              <div className="flex items-center space-x-2">
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="p-2 rounded-full border border-gray-600 dark:text-gray-400 text-textSecondary dark:hover:bg-gray-700/50 hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <ChevronsLeft className="w-4 h-4 border dark:text-[#D9D9D9] dark:border-[#D9D9D9] text-textSecondary rounded-md" />
                </button>

                {getPageNumbers().map((page, index) => (
                  <button
                    key={index}
                    onClick={() =>
                      typeof page === 'number' && handlePageChange(page)
                    }
                    className={`w-8 h-8 rounded-full flex items-center justify-center text-sm ${
                      page === currentPage
                        ? 'bg-gradient-to-r from-pink-500 to-blue-500 text-white'
                        : page === '...'
                          ? 'text-gray-400 cursor-default'
                          : 'dark:bg-gray-700 bg-bgPrimary text-gray-400 dark:hover:bg-gray-600 hover:bg-gray-200'
                    }`}
                    disabled={page === '...'}
                  >
                    {page}
                  </button>
                ))}

                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className="p-2 rounded-full border border-gray-600 dark:text-gray-400 text-textSecondary dark:hover:bg-gray-700/50 hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <ChevronsRight className="w-4 h-4 border dark:text-[#D9D9D9] dark:border-[#D9D9D9] text-textSecondary rounded-md" />
                </button>
              </div>
            </div>
            <div className="flex space-x-2">
              {activeTab === 'shortlisted' && (
                <>
                  {(selectedShortlistedCandidates.length > 0 ||
                    selectedCandidates.length > 0) && (
                    <button
                      className="px-4 py-2 bg-gradient-to-r from-pink-500 to-blue-500 text-white rounded-full text-sm button"
                      onClick={() => setIsSchedulePopup(!isSchedulePopup)}
                    >
                      <span>Schedule Interview</span>
                    </button>
                  )}
                </>
              )}
              {activeTab === 'retrofit' && selectedCandidates.length > 0 && (
                <>
                  <button
                    className="px-4 py-2 bg-gradient-to-r from-pink-500 to-blue-500 text-white rounded-full text-sm button"
                    onClick={shortlistSelectedCandidates}
                  >
                    <span>Shortlist Selected Candidates</span>
                  </button>
                </>
              )}
            </div>
          </div>
        )}
      </>
    );
  };

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="flex flex-col items-center text-center">
          <Loader />
          <p className="dark:text-[#8893C8] text-textSecondary text-sm mt-4">
            Loading candidates...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen text-white overflow-auto">
      <style>{calendarOverrideStyles}</style>
      {showDetails ? (
        <div className="flex-1 px-6">
          {/* Controls section - always visible when showDetails is true */}
          <div className="flex items-center justify-between mt-4">
            <div className="flex space-x-4">
              <button
                onClick={() => handleTabChange('shortlisted')}
                className={`${
                  activeTab === 'shortlisted'
                    ? 'button'
                    : 'border border-gray-700/50 py-2 px-4 rounded-full dark:text-gray-400 text-textSecondary'
                }`}
              >
                <span>{`Shortlisted (${shortlisted.length})`}</span>
              </button>
              <button
                onClick={() => handleTabChange('retrofit')}
                className={`${
                  activeTab === 'retrofit'
                    ? 'button'
                    : 'border border-gray-700/50 py-2 px-4 rounded-full dark:text-gray-400 text-textSecondary'
                }`}
              >
                <span>{`Retrofit (${retrofit.length})`}</span>
              </button>
              <button
                onClick={() => handleTabChange('invalid')}
                className={`${
                  activeTab === 'invalid'
                    ? 'button'
                    : 'border border-gray-700/50 py-2 px-4 rounded-full dark:text-gray-400 text-textSecondary'
                }`}
              >
                <span>{`Invalid (${invalidData.length})`}</span>
              </button>
            </div>
            <div className="flex items-center space-x-4">
              {/* Search Bar */}
              <div className="relative flex items-center">
                <Search className="absolute left-3 w-5 h-5 dark:text-gray-400 text-textSecondary" />
                <input
                  type="text"
                  placeholder="Search by name..."
                  value={searchQuery}
                  autoComplete="off"
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    setCurrentPage(1);
                  }}
                  className="pl-10 pr-10 py-2 dark:bg-gray-800/50 bg-bgPrimary border border-gray-600 rounded-full dark:text-white text-textSecondary text-sm focus:outline-none focus:ring-1 focus:ring-white transition-all"
                />
                {searchQuery && (
                  <CircleX
                    className="absolute right-3 w-5 h-5 text-gray-400 cursor-pointer dark:hover:text-white hover:text-gray-500"
                    onClick={() => {
                      setSearchQuery('');
                      setCurrentPage(1);
                    }}
                  />
                )}
              </div>

              {/* Filter Button */}
              <div className="relative" ref={filterRef}>
                <button
                  className="flex items-center gap-2 dark:glass-effect border dark:border-gray-600 border-gray-300 rounded-full px-3 py-2 dark:text-gray-300 text-textSecondary dark:hover:bg-gray-700/50 hover:bg-gray-100 text-sm font-light"
                  onClick={() => setShowFilterDropdown(!showFilterDropdown)}
                >
                  <SlidersHorizontal className="w-5 h-5" />
                  <span>Filter</span>
                  {filterCount > 0 && (
                    <span className="ml-2 bg-gradient-to-r from-pink-500 to-blue-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs absolute -right-2 -top-1">
                      {filterCount}
                    </span>
                  )}
                </button>
                {showFilterDropdown && (
                  <div className=" absolute right-0 mt-2 w-[400px] border border-gray-600 rounded-lg shadow-sm dark:shadow-lg z-20 p-6 dark:bg-[linear-gradient(233.57deg,rgba(34,52,97,0.25)_-5.01%,rgba(11,10,31,0.05)_100%)] bg-bgPrimary [backdrop-filter:blur(500px)]">
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="text-lg font-medium dark:text-[#D9D9D9] text-textSecondary">
                        Filter
                      </h3>
                      <button
                        onClick={() => setShowFilterDropdown(false)}
                        className="dark:text-gray-400 text-textSecondary dark:hover:text-white hover:text-gray-400"
                      >
                        <X className="w-5 h-5" />
                      </button>
                    </div>

                    {activeFilters.length > 0 && (
                      <div className="mb-4">
                        <div className="flex items-center justify-between mb-2">
                          <label className="text-sm font-medium dark:text-[#D8D8D8] text-textSecondary">
                            Active Filters
                          </label>
                          <button
                            onClick={handleResetFilter}
                            className="text-xs text-blue-400 hover:text-blue-300"
                          >
                            Clear All
                          </button>
                        </div>
                        <div className="flex flex-wrap gap-2">
                          {activeFilters.map((filter, index) => (
                            <div
                              key={index}
                              className="flex items-center dark:bg-gray-700/50 bg-violet-600 dark:text-[#D9D9D9] text-xs px-3 py-1 rounded-full dark:border-green-400 border border-violet-900 text-white"
                            >
                              <span>{filter.label}</span>
                              <button
                                onClick={filter.onRemove}
                                className="ml-2 dark:text-gray-400 hover:text-white text-gray-200"
                              >
                                <X className="w-4 h-4" />
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    {/* ZIP Filter */}
                    <div className="space-y-4">
                      <div>
                        <label className="block text-sm dark:text-gray-300 text-textSecondary mb-2">
                          ZIP Files
                        </label>
                        <div className="space-y-2 max-h-32 overflow-y-auto">
                          <label className="flex items-center space-x-2 cursor-pointer">
                            <input
                              type="radio"
                              name="zip"
                              value="All"
                              checked={tempSelectedFilter === 'All'}
                              onChange={() => handleFilterSelect('All')}
                              className="text-blue-500 focus:ring-blue-500 accent-blue-600"
                            />
                            <span className="text-sm dark:text-gray-300 text-textSecondary">
                              All ZIP Files
                            </span>
                          </label>
                          {notification.map((notif) => {
                            const dateObj = new Date(notif.bulk_upload_date);
                            const formattedDate = dateObj.toLocaleDateString(
                              'en-US',
                              {
                                day: 'numeric',
                                month: 'short',
                                year: 'numeric',
                              },
                            );

                            // Add time if available
                            let timeString = '';
                            if (notif.bulk_upload_date) {
                              const timeFormatted = dateObj.toLocaleTimeString(
                                'en-US',
                                {
                                  hour: 'numeric',
                                  minute: '2-digit',
                                  hour12: true,
                                },
                              );
                              timeString = ` at ${timeFormatted}`;
                            }

                            return (
                              <label
                                key={notif.upload_id}
                                className="flex items-center space-x-2 cursor-pointer"
                              >
                                <input
                                  type="radio"
                                  name="zip"
                                  value={notif.upload_id}
                                  checked={
                                    tempSelectedFilter === notif.upload_id
                                  }
                                  onChange={() =>
                                    handleFilterSelect(notif.upload_id)
                                  }
                                  className="text-blue-500 focus:ring-blue-500"
                                />
                                <span className="text-sm dark:text-gray-300 text-textSecondary">
                                  {formattedDate}
                                  {timeString}
                                </span>
                              </label>
                            );
                          })}
                        </div>
                      </div>

                      {/* Date Range Filter */}
                      <div>
                        <label className="block text-sm dark:text-gray-300 text-textSecondary mb-2">
                          Date Range
                        </label>
                        <div className="relative" ref={calendarRef}>
                          <button
                            className="flex items-center justify-between w-full dark:glass-effect bg-bgPrimary border border-gray-600 rounded-full px-4 py-2 dark:text-gray-300 text-textPrimary dark:hover:bg-gray-700/50 hover:bg-gray-50 text-sm font-light h-10"
                            onClick={(e) => {
                              e.stopPropagation();
                              setIsCalendarOpen(!isCalendarOpen);
                            }}
                            aria-expanded={isCalendarOpen}
                          >
                            <span className="truncate">
                              {formatDateRange(tempFilterDateRange)}
                            </span>
                            {tempFilterDateRange?.length === 2 && tempFilterDateRange[0] ? (
                              <X
                                className="w-4 h-4"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setTempFilterDateRange([null, null]);
                                  setIsCalendarOpen(false);
                                }}
                              />
                            ) : (
                              <ChevronDown className="w-4 h-4" />
                            )}
                          </button>
                          {isCalendarOpen && (
                            <div
                              className="candidate-analytics-calendar absolute mt-2 z-[100] right-0"
                              style={{
                                background: theme === 'dark' ? "#0a1733" : "#fff",
                                border: "1px solid #4b5563",
                                borderRadius: "8px"
                              }}
                            >
                              <div className={`platform-calendar ${theme}`}>
                                <PlatformCalendar
                                  onChange={(value) => {
                                    setTempFilterDateRange(value);
                                    if (value[0] && value[1]) {
                                      setIsCalendarOpen(false);
                                    }
                                  }}
                                  value={tempFilterDateRange}
                                  selectRange={true}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Filter Actions */}
                      <div className="flex space-x-2 pt-4 border-t border-gray-600">
                        <button
                          onClick={handleResetFilter}
                          className="flex-1 px-4 py-2 border border-gray-600 rounded-full dark:text-gray-300 text-textSecondary dark:hover:bg-gray-700/50 hover:bg-gray-200 text-sm"
                        >
                          Reset All
                        </button>
                        <button
                          onClick={handleApplyFilters}
                          className="flex-1 px-4 py-2 bg-gradient-to-r from-pink-500 to-blue-500 text-white rounded-full text-sm hover:opacity-90"
                        >
                          Apply Now
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <button
                className="flex items-center gap-2 dark:glass-effect border dark:border-gray-600 border-gray-300 rounded-full px-3 py-2 dark:text-gray-300 text-textSecondary dark:hover:bg-gray-700/50 hover:bg-gray-100 text-sm font-light"
                onClick={() => {
                  if (
                    (activeTab === 'shortlisted' &&
                      selectedShortlistedCandidates.length > 0) ||
                    (activeTab !== 'shortlisted' &&
                      selectedCandidates.length > 0)
                  ) {
                    setIsDeletePopup(true);
                  } else {
                    toast.error('Please select candidates to delete');
                  }
                }}
              >
                <Trash className="w-5 h-5 dark:text-[#C1A0D0] text-textSecondary" />
                <span>Delete</span>
              </button>

              <button
                className="flex items-center gap-2 dark:glass-effect border dark:border-gray-600 border-gray-300 rounded-full px-3 py-2 dark:text-gray-300 text-textSecondary dark:hover:bg-gray-700/50 hover:bg-gray-100 text-sm font-light"
                onClick={downloadExcel}
              >
                <Download className="w-5 h-5 dark:text-[#C1A0D0] text-textSecondary" />
                <span>Download Excel</span>
              </button>
            </div>
          </div>
          {renderTable(currentData)}
        </div>
      ) : (
        <>
          {filteredNotifications.length === 0 ? (
            <>
              <div className="flex flex-col items-center text-center">
                <Loader />
                <p className="dark:text-[#8893C8] text-textSecondary text-sm mt-4">
                  Loading candidates...
                </p>
              </div>
            </>
          ) : notification.length === 0 ? (
            <>
              <div className="flex flex-col items-center text-center">
                <p className="text-lg font-medium text-gray-200 mb-1">
                  No bulk uploads found
                </p>
              </div>
            </>
          ) : (
            <>
              <div className="flex flex-col items-center text-center">
                <Loader />
                <p className="dark:text-[#8893C8] text-textSecondary text-sm mt-4">
                  Loading candidates...
                </p>
              </div>
            </>
          )}
        </>
      )}

      {/* Analysis Report Modal */}
      {/* !!currentReport */}
      <Dialog
        open={!!currentReport}
        onClose={closeModal}
        maxWidth="md"
        scroll="body"
        fullWidth
        PaperProps={{
          sx: {
            background: `${theme === 'dark' ? 'linear-gradient(to bottom right, rgba(34,52,97,0.25), rgba(11,10,31,0.05))' : ''}`,
            backdropFilter: 'blur(50px)',
            WebkitBackdropFilter: 'blur(50px)',
            maxHeight: 'none',
            height: 'auto',
          },
        }}
        TransitionProps={{
          timeout: 0,
        }}
      >
        <DialogTitle className="flex justify-between items-center px-6 py-4">
          <span className="dark:text-[#8893C8] text-textPrimary text-sm font-medium">
            Analysis Report
          </span>

          <div className="flex items-center gap-3">
            {currentReport?.resume_s3_url ? (
              <button
                className="flex items-center gap-2 hover:opacity-80 transition-opacity"
                onClick={handleViewResume}
              >
                <Download className="w-4 h-4 dark:text-[#C9A3FF] text-textSecondary" />
                <span className="dark:text-[#C9A3FF] text-textSecondary font-normal text-sm">
                  Download Resume
                </span>
              </button>
            ) : (
              <span className="text-gray-500 text-xs italic">No Resume</span>
            )}

            {/* Close Button */}
            <IconButton
              onClick={closeModal}
              size="small"
              sx={{
                color: '#8893C8',
                '&:hover': { color: 'white' },
                padding: '4px',
              }}
            >
              <CloseIcon
                fontSize="small"
                className="dark:text-white text-textSecondary"
              />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent
          className=" dark:text-white text-textPrimary"
          sx={{ maxHeight: 'none', overflow: 'visible' }}
        >
          {currentReport && Object.keys(currentReport).length > 0 ? (
            <div className="w-full px-4 sm:px-0 pt-5">
              <div className="rounded-3xl dark:shadow-xl shadow-sm p-4 sm:p-6 border border-gray-700/50">
                <div className="flex space-x-6">
                  <div className="h-36 w-36 relative">
                    <CircularProgressbar
                      value={
                        currentReport.score === null ||
                        currentReport.score === undefined ||
                        currentReport.score === 'NA' ||
                        currentReport.score === 'ERROR'
                          ? 0
                          : currentReport.score
                      }
                      text={
                        currentReport.score === null ||
                        currentReport.score === undefined ||
                        currentReport.score === 'NA' ||
                        currentReport.score === 'ERROR'
                          ? 'NA'
                          : `${currentReport.score}%`
                      }
                      circleRatio={0.75}
                      styles={buildStyles({
                        rotation: 1 / 2 + 1 / 8,
                        strokeLinecap: 'butt',
                        trailColor:
                          currentReport.score === null ||
                          currentReport.score === undefined ||
                          currentReport.score === 'NA' ||
                          currentReport.score === 'ERROR'
                            ? getScoreColorGradient(0)
                            : getScoreColorGradient(currentReport.score),
                        pathColor:
                          currentReport.score === null ||
                          currentReport.score === undefined ||
                          currentReport.score === 'NA' ||
                          currentReport.score === 'ERROR'
                            ? getPathColor(0)
                            : getPathColor(currentReport.score),
                        textColor: `${theme === 'dark' ? '#FFFFFF' : '#525252'}`,
                        textSize: '20px',
                      })}
                    />
                    <div
                      style={{
                        position: 'absolute',
                        width: '100%',
                        textAlign: 'center',
                        color: `${theme === 'dark' ? '#FFFFFF99' : '#525252'}`,
                        fontSize: '14px',
                        fontWeight: 'normal',
                        bottom: '10px',
                      }}
                    >
                      Score
                    </div>
                  </div>
                  <div className="flex-1 flex-col space-y-6 dark:text-white text-textSecondary pl-4">
                    <div className="flex-1 flex justify-between">
                      <div className="flex-1 flex flex-col border-r border-[#484474]">
                        <span className="dark:text-[#8893C8] text-textSecondary text-sm font-semibold">
                          Experience Match
                        </span>
                        <div className="dark:text-[#D0D5EF] text-textSecondary mt-2">
                          {Array.isArray(currentReport.experience_match) &&
                          currentReport.experience_match.length > 0 ? (
                            currentReport.experience_match.map((exp, index) => (
                              <span
                                key={index}
                                style={{
                                  color:
                                    exp.meets_requirement &&
                                    exp.meets_requirement.toLowerCase() ===
                                      'yes'
                                      ? '#34B53A'
                                      : '#DC0000',
                                }}
                              >
                                {exp.candidate_experience}
                              </span>
                            ))
                          ) : (
                            <span className="dark:text-[#D0D5EF] text-textSecondary">
                              No experience data available
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="flex-1 flex flex-col border-r border-[#484474] pl-5">
                        <span className="dark:text-[#8893C8] text-textSecondary text-sm font-semibold">
                          Location
                        </span>
                        <span className="dark:text-[#D0D5EF] text-textSecondary mt-2">
                          {currentReport.location_match &&
                          Object.keys(currentReport.location_match).length > 0
                            ? `${
                                currentReport.location_match.candidate_location?.split(
                                  ',',
                                )[0] || 'Not specified'
                              }`
                            : 'No location data available'}
                        </span>
                      </div>
                      <div className="flex-1 flex flex-col pl-5">
                        <span className="dark:text-[#8893C8] text-textSecondary text-sm font-semibold">
                          Education
                        </span>
                        <span className="dark:text-[#D0D5EF] text-textSecondary mt-2">
                          {currentReport.education_match &&
                          currentReport.education_match
                            .candidate_highest_education
                            ? currentReport.education_match
                                .candidate_highest_education
                            : 'No education data available'}
                        </span>
                      </div>
                    </div>
                    <div className="mt-5 border-t border-[#484474]"></div>
                    <div className="flex-1 flex justify-between">
                      <div className="flex flex-col border-r border-[#484474] w-[32%]">
                        <span className="dark:text-[#8893C8] text-textSecondary text-sm font-semibold">
                          Red Flags
                        </span>
                        <span className="dark:text-[#D0D5EF] text-textSecondary mt-2">
                          {Array.isArray(currentReport.red_flags) &&
                          currentReport.red_flags.length > 0
                            ? currentReport.red_flags.join(', ')
                            : 'None'}
                        </span>
                      </div>
                      <div className="flex-1 flex flex-col border-[#484474] pl-5">
                        <span className="dark:text-[#8893C8] text-textSecondary text-sm font-semibold">
                          Tech/Tools Match
                        </span>
                        <div className="mt-2">
                          {Array.isArray(currentReport.tech_tool_match) &&
                          currentReport.tech_tool_match.length > 0 ? (
                            <div className="flex flex-wrap gap-3">
                              {currentReport.tech_tool_match
                                .sort((a, b) => {
                                  const aStatus =
                                    a.skill_status?.toLowerCase() === 'yes';
                                  const bStatus =
                                    b.skill_status?.toLowerCase() === 'yes';
                                  if (aStatus && !bStatus) return -1;
                                  if (!aStatus && bStatus) return 1;
                                  return 0;
                                })
                                .map((skill, index) => (
                                  <SkillBadge
                                    key={index}
                                    skill={skill.skill_name}
                                    status={
                                      skill.skill_status?.toLowerCase() ===
                                      'yes'
                                        ? 'yes'
                                        : 'no'
                                    }
                                  />
                                ))}
                            </div>
                          ) : (
                            <span className="dark:text-[#D0D5EF] text-textSecondary">
                              No tech/tools data available
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-5 border-t border-[#484474]">
                  <div className="flex justify-between mt-5">
                    <div className="flex-1 flex flex-col border-r border-[#484474] pr-5">
                      <span className="dark:text-[#8893C8] text-textSecondary text-sm font-semibold">
                        Highlights
                      </span>
                      <span className="dark:text-[#D0D5EF] text-textSecondary mt-2">
                        {Array.isArray(currentReport.Strengths) &&
                        currentReport.Strengths.length > 0
                          ? currentReport.Strengths.map((point) =>
                              point.replace(/^- /, '').trim(),
                            ).join(' ')
                          : 'No highlights available'}
                      </span>
                    </div>
                    <div className="flex-1 flex flex-col border-[#484474] pl-5">
                      <span className="dark:text-[#8893C8] text-textSecondary text-sm font-semibold">
                        Lowlights
                      </span>
                      <span className="dark:text-[#D0D5EF] text-textSecondary mt-2">
                        {Array.isArray(currentReport.Weaknesses) &&
                        currentReport.Weaknesses.length > 0
                          ? currentReport.Weaknesses.map((point) =>
                              point.replace(/^- /, '').trim(),
                            ).join(' ')
                          : 'No lowlights available'}
                      </span>
                    </div>
                  </div>
                  <div className="flex-1 flex flex-col mt-5 border-t border-[#484474]">
                    <span className="dark:text-[#8893C8] text-textSecondary text-sm font-semibold mt-5">
                      Suggestions
                    </span>
                    <span className="dark:text-[#D0D5EF] text-textSecondary mt-2">
                      {Array.isArray(currentReport.Suggestions) &&
                      currentReport.Suggestions.length > 0
                        ? currentReport.Suggestions.map((point) =>
                            point.replace(/^- /, '').trim(),
                          ).join(' ')
                        : 'No suggestions available'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <p className="dark:text-[#D0D5EF] text-textSecondary">
              No report available
            </p>
          )}
          {currentCandidate && (
            <div className="flex justify-end gap-3 mt-6 px-2 pb-2">
              <button
                className={
                  theme === 'dark'
                    ? 'button text-sm hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed'
                    : 'border-btn hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed'
                }
                onClick={() => {
                  closeModal(); // Close the analysis report modal
                }}
              >
                <span className="dark:text-white text-textSecondary">
                  Close
                </span>
              </button>
              <button
                className="px-4 py-2 bg-gradient-to-r from-pink-500 to-blue-500 text-white rounded-full text-sm button hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={() => {
                  if (activeTab === 'shortlisted') {
                    setSelectedShortlistedCandidates([currentCandidate]);
                  } else {
                    setSelectedCandidates([currentCandidate]);
                  }
                  setIsSchedulePopup(true);
                  closeModal(); // Close the analysis report modal
                }}
                disabled={
                  currentCandidate?.interview_id &&
                  currentCandidate?.status === 'scheduled'
                }
              >
                <span className="text-white">Schedule Interview</span>
              </button>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <ConfirmationDialog
        open={isDeletePopup}
        onClose={() => setIsDeletePopup(false)}
        title="Delete Candidates"
        message={`Are you sure you want to delete ${
          activeTab === 'shortlisted'
            ? selectedShortlistedCandidates.length
            : selectedCandidates.length
        } selected candidate${
          (activeTab === 'shortlisted'
            ? selectedShortlistedCandidates.length
            : selectedCandidates.length) > 1
            ? 's'
            : ''
        }?`}
        confirmText="Delete"
        cancelText="Cancel"
        onConfirm={
          activeTab === 'shortlisted'
            ? deleteSelectedShortlistedCandidates
            : deleteSelectedCandidates
        }
      />

      {/* Schedule Interview Dialog */}
      <Dialog
        open={schedulePopupOpen}
        onClose={() => setIsSchedulePopup(false)}
        PaperProps={{
          sx: {
            background: `${theme === 'dark' ? 'linear-gradient(to bottom right, rgba(34,52,97,0.25), rgba(11,10,31,0.05))' : ''}`,
            backdropFilter: 'blur(50px)',
            WebkitBackdropFilter: 'blur(50px)',
            borderRadius: '12px',
            padding: '10px',
            maxWidth: '600px',
            width: '100%',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
          },
        }}
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            transition: 'none !important',
          },
        }}
        TransitionProps={{
          timeout: 0,
        }}
      >
        <DialogTitle
          sx={{
            fontFamily: 'Poppins',
            color: `${theme === 'dark' ? 'white' : '#525252'}`,
            fontSize: '1.10rem',
            fontWeight: 400,
            position: 'relative',
            pr: 6,
          }}
        >
          Schedule Interview
          <IconButton
            aria-label="close"
            onClick={() => setIsSchedulePopup(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: '50%',
              transform: 'translateY(-50%)',
              color: theme === 'dark' ? 'white' : '#525252',
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              alignItems: 'left',
            }}
          >
            <div className={`platform-calendar ${theme}`}>
              <PlatformCalendar
                onChange={(value) => setDateRange(value)}
                value={dateRange}
                selectRange={true}
                minDate={new Date()}
              />
            </div>
          </Box>
        </DialogContent>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1, gap: 1 }}>
          <Button
            onClick={() => {
              setDateRange([null, null]);
            }}
            sx={{
              textTransform:"none",
              fontFamily: 'Poppins',
              fontWeight: 300,
              // color: "white",
            }}
            className={`${
              theme === 'dark'
                ? 'border border-gray-600 !text-gray-300'
                : 'border-btn !text-textSecondary'
            }`}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            onClick={scheduleInterviewForAll}
            disabled={!dateRange[0] || !dateRange[1]}
            sx={{
              textTransform:"none",
              fontFamily: 'Poppins',
              fontWeight: 300,
              background: 'linear-gradient(to left, #FB54AE, #2F64FF)',
              color: 'white',
              borderRadius: '9999px',
              '&.Mui-disabled': {
                background: 'linear-gradient(to left, #FB54AE, #2F64FF)',
                opacity: 0.6,
                color: 'white',
              },
            }}
          >
            Schedule
          </Button>
        </Box>
      </Dialog>
    </div>
  );
};

// Test user

export default ActivityOrgAdmin;
